// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__24P67","content":"Consent_content__2tnVB","footer":"Consent_footer__1ZL7G"};